<template>
    <rt-view>
        <rt-header>
            <rt-detail-header>
                <rt-header-icon slot="icon" icon="rt-base-account" />
                <rt-header-title :title="'变更申请详情'" sub-title="">
                </rt-header-title>
                <template slot="btn">
                    <rt-button style="margin-left:10px" class="add-button" type="approve-progress" @click="approvalProgress()">审批进度</rt-button>
            </template>
            </rt-detail-header>
        </rt-header>
        <rt-content v-loading="orderLoading">
            <rt-form :model="Model" label-width="120px" ref="channelOrderRef">
                <rt-section title="基本信息" icon="rt-portal-SALESMANAGEMENT">
                    <rt-row :gutter="20">
                        <rt-col :span="6">
                            <rt-form-item label="变更申请详情单号" prop="new_name">
                                <rt-input showLabel="true" disabled v-model="Model.new_name"  />
                            </rt-form-item>
                        </rt-col> 
                        <rt-col :span="6">
                            <rt-form-item label="创建时间" prop="createdon">
                                <rt-input showLabel="true" disabled v-model="Model.createdon"  />
                            </rt-form-item>
                        </rt-col> 
                        <rt-col :span="6">
                            <rt-form-item label="取消原因" prop="new_cancel_reason">
                                <rt-input showLabel="true" disabled v-model="Model.new_cancel_reason" />
                            </rt-form-item>
                        </rt-col> 
                        <rt-col :span="6">
                        <rt-form-item label="订单号" prop="new_saleorder_id">
                            <rt-lookup lookup-style="single" disabled v-model="Model.new_saleorder_id"   />
                        </rt-form-item>
                    </rt-col>
                    <rt-col :span="6">
                        <rt-form-item label="商机名称" prop="new_opportunity_idsj">
                            <rt-lookup lookup-style="single" disabled v-model="Model.new_opportunity_idsj"   />
                        </rt-form-item>
                    </rt-col>
                    <rt-col :span="6">
                        <rt-form-item label="下级渠道" prop="new_account_idqd">
                            <rt-lookup lookup-style="single" disabled v-model="Model.new_account_idqd"   />
                        </rt-form-item>
                    </rt-col>
                    <rt-col :span="6">
                        <rt-form-item label="总代所属销售" prop="new_agentsales_id">
                            <rt-lookup lookup-style="single" disabled v-model="Model.new_agentsales_id"   />
                        </rt-form-item>
                    </rt-col>
                    <rt-col :span="6">
                        <rt-form-item label="负责人" prop="ownerid">
                            <rt-lookup lookup-style="single" disabled v-model="Model.ownerid"   />
                        </rt-form-item>
                    </rt-col>
                    <rt-col :span="6" v-show="false">
                        <rt-form-item  label="更新订单结果" prop="new_order_result">
                            <rt-picklist disabled v-model="Model.new_order_result.text" />
                        </rt-form-item>
                    </rt-col>
                    <rt-col :span="6">
                        <rt-form-item label="订单类型" prop="new_ord_type_id">
                            <rt-lookup lookup-style="single" disabled v-model="Model.new_ord_type_id"   />
                        </rt-form-item>
                    </rt-col>
                    <rt-col :span="6" v-show="false">
                        <rt-form-item label="更新渠道订单结果" prop="new_channel_order_result">
                            <rt-picklist disabled v-model="Model.new_channel_order_result.text" />
                        </rt-form-item>
                    </rt-col>
                    <rt-col :span="6" v-show="false">
                            <rt-form-item label="是否使用电子签章" prop="new_use_electronic_signature">
                                <rt-input showLabel="true" disabled v-model="Model.new_use_electronic_signature"  />
                            </rt-form-item>
                        </rt-col> 
                        <rt-col :span="6" v-show="false">
                        <rt-form-item label="更新库存产品占用明细结果" prop="new_product_occupancy_result">
                            <rt-picklist disabled v-model="Model.new_product_occupancy_result.text" />
                        </rt-form-item>
                    </rt-col>
                    <rt-col :span="6">
                            <rt-form-item label="最终客户" prop="new_end_customer">
                                <rt-input showLabel="true" disabled v-model="Model.new_end_customer"  />
                            </rt-form-item>
                        </rt-col> 
                        <rt-col :span="6" v-show="false">
                        <rt-form-item label="更新软件实际发货数量结果" prop="new_actual_shipment_result">
                            <rt-picklist disabled v-model="Model.new_actual_shipment_result.text" />
                        </rt-form-item>
                    </rt-col>
                    <rt-col :span="6">
                        <rt-form-item label="审批状态" prop="new_approvalstatus">
                            <rt-picklist disabled v-model="Model.new_approvalstatus.text" />
                        </rt-form-item>
                    </rt-col>
                    <rt-col :span="6" v-show="false">
                        <rt-form-item label="更新渠道发货单结果" prop="new_channel_shipment_result">
                            <rt-picklist disabled v-model="Model.new_channel_shipment_result.text" />
                        </rt-form-item>
                    </rt-col>
                    <rt-col :span="6" v-show="false">
                        <rt-form-item label="更新过单点结果" prop="new_order_point_result">
                            <rt-picklist disabled v-model="Model.new_order_point_result.text" />
                        </rt-form-item>
                    </rt-col>
                    <rt-col :span="6">
                        <rt-form-item label="状态" prop="statecode">
                            <rt-picklist disabled v-model="Model.statecode.text" />
                        </rt-form-item>
                    </rt-col>
                    <rt-col :span="6" v-show="false">
                        <rt-form-item label="释放stockunit结果" prop="new_stockunit_result">
                            <rt-picklist disabled v-model="Model.new_stockunit_result.text" />
                        </rt-form-item>
                    </rt-col>
                    <rt-col :span="6" v-show="false">
                        <rt-form-item label="释放返利结果" prop="new_rebate_result">
                            <rt-picklist disabled v-model="Model.new_rebate_result.text" />
                        </rt-form-item>
                    </rt-col>   
                    <rt-col :span="6" v-show="false">
                        <rt-form-item label="更新内部交易单结果" prop="new_transaction_result">
                            <rt-picklist disabled v-model="Model.new_transaction_result.text" />
                        </rt-form-item>
                    </rt-col> 
                    <rt-col :span="6" v-show="false">
                        <rt-form-item label="同步WMS状态" prop="new_sync_wms_status">
                            <rt-picklist disabled v-model="Model.new_sync_wms_status.text" />
                        </rt-form-item>
                    </rt-col> 
                    <rt-col :span="6" v-show="false">
                        <rt-form-item label="同步EBS发货单状态" prop="new_sync_ebs_shipment_status">
                            <rt-picklist disabled v-model="Model.new_sync_ebs_shipment_status.text" />
                        </rt-form-item>
                    </rt-col> 
                    <rt-col :span="6" v-show="false">
                        <rt-form-item label="同步EBS订单状态" prop="new_sync_ebs_order_status">
                            <rt-picklist disabled v-model="Model.new_sync_ebs_order_status.text" />
                        </rt-form-item>
                    </rt-col> 
                    </rt-row>                  
                </rt-section>
            </rt-form>
        </rt-content>
        <rt-section title="订单变更申请产品" icon="rt-portal-SALESMANAGEMENT">
        <rt-row>
            <rt-col :span="24">
                <rt-table style="width: 100%" border tooltip-effect="dark" :sectionable="false" :showPagination="false" :need-fetch="false" :no-needfetch-data="Model.oclist">
                    <rt-table-column label="编号" prop="new_name">
                    </rt-table-column>
                    <rt-table-column label="变更申请单号" prop="new_change_application_id">
                        <template slot-scope="scope">
                            {{ scope.row.new_change_application_id? scope.row.new_change_application_id.name:'' }}
                        </template>
                    </rt-table-column>
                    <rt-table-column label="订单产品行号" prop="new_ord_saleorderdetail_id">
                        <template slot-scope="scope">
                            {{ scope.row.new_ord_saleorderdetail_id? scope.row.new_ord_saleorderdetail_id.name:'' }}
                        </template>
                    </rt-table-column>
                    <rt-table-column label="发货产品行号" prop="new_invoice_product_id">
                        <template slot-scope="scope">
                            {{ scope.row.new_invoice_product_id? scope.row.new_invoice_product_id.name:'' }}
                        </template>
                    </rt-table-column>
                    <rt-table-column label="发货单号" prop="new_ord_shipment_id">
                        <template slot-scope="scope">
                            {{ scope.row.new_ord_shipment_id? scope.row.new_ord_shipment_id.name:'' }}
                        </template>
                    </rt-table-column>
                    <rt-table-column label="产品名称" prop="new_product_id">
                        <template slot-scope="scope">
                            {{ scope.row.new_product_id? scope.row.new_product_id.name:'' }}
                        </template>
                    </rt-table-column>
                    <rt-table-column label="业务群" prop="new_productgroup_id">
                        <template slot-scope="scope">
                            {{ scope.row.new_productgroup_id? scope.row.new_productgroup_id.name:'' }}
                        </template>
                    </rt-table-column>
                    <rt-table-column label="子产品线" prop="new_product_line">
                        <template slot-scope="scope">
                            {{ scope.row.new_product_line }}
                        </template>
                    </rt-table-column>
                    <rt-table-column label="服务月份" prop="new_sevicemonths">
                        <template slot-scope="scope">
                            {{ scope.row.new_sevicemonths }}
                        </template>
                    </rt-table-column>
                    <rt-table-column label="取消数量" prop="new_cancel_quantity">
                        <template slot-scope="scope">
                            {{ scope.row.new_cancel_quantity }}
                        </template>
                    </rt-table-column>
                    <rt-table-column label="交货数量" prop="new_delivery_quantity">
                        <template slot-scope="scope">
                            {{ scope.row.new_delivery_quantity }}
                        </template>
                    </rt-table-column>
                    <rt-table-column label="成交价" prop="new_current_rate">
                        <template slot-scope="scope">
                            {{ scope.row.new_current_rate }}
                        </template>
                    </rt-table-column>
                    <rt-table-column label="取消金额" prop="cancelAmount">
                        <template slot-scope="scope">
                            {{ scope.row.cancelAmount }}
                        </template>
                    </rt-table-column> 
                    <rt-table-column label="是否涉及硬件实体交付" prop="new_involves_hardware_delivery">
                        <template slot-scope="scope">
                            {{ scope.row.new_involves_hardware_delivery }}
                        </template>
                    </rt-table-column>
                    <template slot="empty">
                        <img style="margin-top:50px" src="../../assets/imgs/home/no-order.png" alt />
                        <p class="nodata-prompt">
                            Sorry！未找到相应结果哦~换个关键词试试！
                        </p>
                    </template>
                </rt-table>
            </rt-col>
        </rt-row>
    </rt-section>
    <rt-section title="订单变更申请POSKU明细" icon="rt-portal-SALESMANAGEMENT">
        <rt-row>
            <rt-col :span="24">
                <rt-table style="width: 100%" border tooltip-effect="dark" :sectionable="false" :showPagination="false" :need-fetch="false" :no-needfetch-data="Model.opdlis">
                    <rt-table-column label="编号" prop="new_name">
                    </rt-table-column>
                    <rt-table-column label="变更申请单号" prop="new_order_change_id">
                        <template slot-scope="scope">
                            {{ scope.row.new_order_change_id? scope.row.new_order_change_id.name:'' }}
                        </template>
                    </rt-table-column>
                    <rt-table-column label="产品" prop="new_product_id">
                        <template slot-scope="scope">
                            {{ scope.row.new_product_id? scope.row.new_product_id.name:'' }}
                        </template>
                    </rt-table-column>
                    <rt-table-column label="变更产品行号" prop="new_change_product_id">
                        <template slot-scope="scope">
                            {{ scope.row.new_change_product_id? scope.row.new_change_product_id.name:'' }}
                        </template>
                    </rt-table-column>

                    <rt-table-column label="产品POSKU" prop="new_posku_id">
                        <template slot-scope="scope">
                            {{ scope.row.new_posku_id? scope.row.new_posku_id.name:'' }}
                        </template>
                    </rt-table-column>

                    <rt-table-column label="订单POSKU明细" prop="new_ord_saleorderline_id">
                        <template slot-scope="scope">
                            {{ scope.row.new_ord_saleorderline_id? scope.row.new_ord_saleorderline_id.name:'' }}
                        </template>
                    </rt-table-column>
                    <rt-table-column label="子产品线" prop="new_subproductline_1">
                        <template slot-scope="scope">
                            {{ scope.row.new_subproductline_1 }}
                        </template>
                    </rt-table-column>
                    <rt-table-column label="物料类别" prop="new_materialtype_id">
                        <template slot-scope="scope">
                            {{ scope.row.new_materialtype_id? scope.row.new_materialtype_id.name:'' }}
                        </template>
                    </rt-table-column>
                    <rt-table-column label="服务月份" prop="new_smonths">
                        <template slot-scope="scope">
                            {{ scope.row.new_smonths }}
                        </template>
                    </rt-table-column>
                    <rt-table-column label="成交价" prop="new_finalprice">
                        <template slot-scope="scope">
                            {{ scope.row.new_finalprice }}
                        </template>
                    </rt-table-column>
                   
                    <rt-table-column label="发货数量" prop="new_shipment_quantity">
                        <template slot-scope="scope">
                            {{ scope.row.new_shipment_quantity }}
                        </template>
                    </rt-table-column>
                    <rt-table-column label="取消数量" prop="new_cancel_quantity">
                        <template slot-scope="scope">
                            {{ scope.row.new_cancel_quantity }}
                        </template>
                    </rt-table-column>
                    <rt-table-column label="取消金额" prop="cancelAmount">
                        <template slot-scope="scope">
                            {{ scope.row.cancelAmount }}
                        </template>
                    </rt-table-column> 
                    <rt-table-column label="发货单明细" prop="new_ord_shipmentline_id">
                        <template slot-scope="scope">
                            {{ scope.row.new_ord_shipmentline_id? scope.row.new_ord_shipmentline_id.name:'' }}
                        </template>
                    </rt-table-column>
                    <rt-table-column label="C SKU开票名称" prop="new_csku">
                        <template slot-scope="scope">
                            {{ scope.row.new_csku }}
                        </template>
                    </rt-table-column>
                    <rt-table-column label="POSKU开票名称" prop="new_posku">
                        <template slot-scope="scope">
                            {{ scope.row.new_posku }}
                        </template>
                    </rt-table-column>
                    <rt-table-column label="税率" prop="new_taxrate">
                        <template slot-scope="scope">
                            {{ scope.row.new_taxrate }}
                        </template>
                    </rt-table-column>
                    <template slot="empty">
                        <img style="margin-top:50px" src="../../assets/imgs/home/no-order.png" alt />
                        <p class="nodata-prompt">
                            Sorry！未找到相应结果哦~换个关键词试试！
                        </p>
                    </template>
                </rt-table>
            </rt-col>
        </rt-row>
    </rt-section>
        <rt-file-list v-if="id" style="margin-top: 10px" :can-upload="false" :approvalstatus="Model.new_approvalstatus" :can-delete="false" moduleType="new_ord_saleorder" :objectId="id" icon="rt-portal-FINANCIALMANAGEMENT" :title="Model.new_name"></rt-file-list>
        <RtApprovalProgressDialog ref="approvalDialog" :entity-name="entityname" :entity-id="id"></RtApprovalProgressDialog>
    </rt-view>
    </template>
    
    <script>
    export default {
        components: {
    
        },
        data() {
            return {
                id: "",
                entityname:"new_order_change_application",
                flag: false,
                Model: {
                    new_opportunity_idsj: {
                        id: "",
                        name: ""
                    },
                    new_account_idqd: {
                        id: "",
                        name: ""
                    },
                    new_agentsales_id: {
                        id: "",
                        name: ""
                    },
                    ownerid: {
                        id: "",
                        name: ""
                    },
                    new_order_change_applicationid: "",
                    new_name: "",
                    new_saleorder_id: {
                        id: "",
                        name: ""
                    },
                    new_ord_type_id: {
                        id: "",
                        name: ""
                    },
                    new_end_customer: "",
                    new_cancel_reason: "",
                    new_sync_ebs_shipment_status: {
                        text: "",
                        value: ""
                    }, //p
                    new_sync_ebs_order_status: {
                        text: "",
                        value: ""
                    }, //p
                    new_sync_wms_status: {
                        text: "",
                        value: ""
                    }, //p
                    new_approvalstatus: {
                        text: "",
                        value: ""
                    }, //p
                    new_submit_time: "",
                    new_use_electronic_signature: "",
                    new_transaction_result: {
                        text: "",
                        value: ""
                    }, //p
                    new_product_occupancy_result: {
                        text: "",
                        value: ""
                    }, //p
                    new_channel_shipment_result: {
                        text: "",
                        value: ""
                    }, //p
                    new_channel_order_result: {
                        text: "",
                        value: ""
                    }, //p
                    new_order_result: {
                        text: "",
                        value: ""
                    }, //p
                    new_actual_shipment_result: {
                        text: "",
                        value: ""
                    }, //p
                    new_order_point_result: {
                        text: "",
                        value: ""
                    }, //p
                    statecode: {
                        text: "",
                        value: ""
                    }, //p
                    new_stockunit_result: {
                        text: "",
                        value: ""
                    }, //p
                    new_rebate_result: {
                        text: "",
                        value: ""
                    }, //p
                    createdon: "",

                }
            };
        },
        mounted() {
            if (this.$route.params.id) {
                this.id = this.$route.params.id;
                this.flag = true;;
                this.getData();

            }
        },
        methods: {
 
            //在methods总通过方法计算返回对应class样式
            tabRowClassName({
                row,
                rowIndex
            }) {
                let index = rowIndex + 1;
                if (index % 2 == 0) {
                    return "even-row";
                }
            },

            approvalProgress() {
      this.$refs.approvalDialog.show();
    },
            getData() {
                try {
    
                    this.orderLoading = true
                    let url = `api/NewOrder/GetOrderChangedetail?id=` + this.id;
                    rt.get(url).then(res => {
                        this.orderLoading = false
                        this.Model = res;
                        if (!this.Model.new_opportunity_idsj) this.Model.new_opportunity_idsj = {
                            id: "",
                            name: ""
                        }
                        if (!this.Model.new_account_idqd) this.Model.new_account_idqd = {
                            id: "",
                            name: ""
                        }
                        if (!this.Model.new_agentsales_id) this.Model.new_agentsales_id = {
                            id: "",
                            name: ""
                        }
                        if (!this.Model.ownerid) this.Model.ownerid = {
                            id: "",
                            name: ""
                        }
                        if (!this.Model.new_saleorder_id) this.Model.new_saleorder_id = {
                            id: "",
                            name: ""
                        }
                        if (!this.Model.new_ord_type_id) this.Model.new_ord_type_id = {
                            id: "",
                            name: ""
                        }
                        if (!this.Model.new_sync_ebs_shipment_status) this.Model.new_sync_ebs_shipment_status = {
                        text: "",
                        value: ""
                    }
                    if (!this.Model.new_sync_ebs_order_status) this.Model.new_sync_ebs_order_status = {
                        text: "",
                        value: ""
                    }
                    if (!this.Model.new_sync_wms_status) this.Model.new_sync_wms_status = {
                        text: "",
                        value: ""
                    }
                    if (!this.Model.new_approvalstatus) this.Model.new_approvalstatus = {
                        text: "",
                        value: ""
                    }
                    if (!this.Model.new_transaction_result) this.Model.new_transaction_result = {
                        text: "",
                        value: ""
                    }
                    if (!this.Model.new_product_occupancy_result) this.Model.new_product_occupancy_result = {
                        text: "",
                        value: ""
                    }
                    if (!this.Model.new_channel_shipment_result) this.Model.new_channel_shipment_result = {
                        text: "",
                        value: ""
                    }
                    if (!this.Model.new_channel_order_result) this.Model.new_channel_order_result = {
                        text: "",
                        value: ""
                    }
                    if (!this.Model.new_order_result) this.Model.new_order_result = {
                        text: "",
                        value: ""
                    }
                    if (!this.Model.new_actual_shipment_result) this.Model.new_actual_shipment_result = {
                        text: "",
                        value: ""
                    }
                    if (!this.Model.new_order_point_result) this.Model.new_order_point_result = {
                        text: "",
                        value: ""
                    }
                    if (!this.Model.statecode) this.Model.statecode = {
                        text: "",
                        value: ""
                    }
                    if (!this.Model.new_stockunit_result) this.Model.new_stockunit_result = {
                        text: "",
                        value: ""
                    }
                    if (!this.Model.new_rebate_result) this.Model.new_rebate_result = {
                        text: "",
                        value: ""
                    }   
                    
                        console.log("res",this.Model);
                        
                       
                    }).catch(err => {
                        rt.showErrorToast(err)
                    })
                } catch (error) {
                    this.orderLoading = false
                    rt.showErrorToast(error)
                }
    
            },

        },
    }
    </script>
    
    <style scoped>
    .cus-form .rt-input {
        min-width: 240px;
    }
    
    .cus-form .full-input {
        width: 100%;
    }
    
    .cus-title {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    
    .cus-title>button,
    .cus-title>.el-dropdown {
        margin-right: 15px;
    }
    
    .input_link{
      background: #f1f2f4; /* 禁用状态背景颜色 */
      color: #999; /* 禁用状态文本颜色 */
      border: none;
      cursor: not-allowed; /* 根据需要设置光标样式 */
      pointer-events: none; /* 防止鼠标事件 */
    }
    
    .el-form-item__content .input_quote >>> .el-input__inner {
      border: none;
      background: #999 !important;
      color: blue !important; /* 链接的颜色 */
      text-decoration: underline !important; /* 添加下划线 */
      cursor: pointer !important; /* 鼠标悬停时显示指针 */
    }
    </style>
    


// WEBPACK FOOTER //
// new_order_change_applicationDetail.vue?34b243fa